export interface PendingEnrichmentJob {
  apiKey: string;
  jobId: string | null;
  storedAt: number;
}

const STORAGE_KEY = 'nonGatedEnrichmentJob';

const PENDING_MARKER_TTL_MS = 10 * 60 * 1000;

export const ENRICHMENT_JOB_STORED_EVENT = 'enrichment-job-stored';

export const rememberEnrichmentJob = (job: PendingEnrichmentJob) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(job));
  window.dispatchEvent(new Event(ENRICHMENT_JOB_STORED_EVENT));
};

export const readEnrichmentJob = (): PendingEnrichmentJob | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const job = JSON.parse(raw) as PendingEnrichmentJob;
    if (!job.jobId && Date.now() - job.storedAt > PENDING_MARKER_TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return job;
  } catch {
    return null;
  }
};

export const clearEnrichmentJob = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(ENRICHMENT_JOB_STORED_EVENT));
};
